import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import usePermissions from '../../../hooks/usePermissions'

import UploadAdForms from './UploadAdForms'
import RightCampaigns from './RightCampaigns'
import RightCampaignsReports from './RightCampaignsReports'
import SocialAuthCheckerMulti from '../../../features/components/SocialAuthCheckerMulti'
import CombinedCampaignBudgetEdit from '../../../forms/Multiplatform/CombinedCampaignBudgetEdit'

import { useGetCombinedLineItems } from './RightCampaignsReports/ReportsSections/useGetCombinedLineItems'

import { rightErrorSelector, rightSelector } from '../../../modules/selectors/rights'
import { combinedCampaignsSelector } from '../../../modules/selectors/combinedData'
import { PROVIDER_TO_PLATFORMS } from '../../../constants/selectLists/platformList'

const DigitalRight = () => {
  const rightError = useSelector(rightErrorSelector)
  const right = useSelector(rightSelector)
  const { campaigns_summary: campaignsSummary, campaigns = [] } = useSelector(combinedCampaignsSelector)

  const { campaigns: rightCampaignsToLoad } = right
  const hasRightCampaignsToLoad = !!rightCampaignsToLoad && !!rightCampaignsToLoad.length
  // each campaign has provider field. we need to find all providers which are used for this right campaigns:
  const availablePlatformCampaigns = useMemo(() => {
    if (hasRightCampaignsToLoad) {
      return rightCampaignsToLoad.reduce((acc, campaign) => {
        const platform = PROVIDER_TO_PLATFORMS[campaign.provider]
        if (!acc.includes(platform)) {
          acc.push(platform)
        }
        return acc
      }, [])
    } else {
      return []
    }
  }, [rightCampaignsToLoad, hasRightCampaignsToLoad])

  const permissions = usePermissions()

  const someCombinedCampaignsHasError = useMemo(() => campaigns.some(campaign => campaign.error), [campaigns])

  // still show buttons while right is loading
  const showUploadAdForms = useMemo(
    () => !rightError && permissions.can('Create', 'Ad') && !someCombinedCampaignsHasError,
    [rightError, someCombinedCampaignsHasError, permissions]
  )
  const hasImpressions = !!campaignsSummary?.impressions

  const showRightCampaignsReports = useMemo(
    () => hasImpressions && !someCombinedCampaignsHasError,
    [hasImpressions, someCombinedCampaignsHasError]
  )

  const showCombinedCampaignBudgetEdit = !someCombinedCampaignsHasError

  useGetCombinedLineItems()

  return (
    <>
      {showUploadAdForms && <UploadAdForms />}
      {showCombinedCampaignBudgetEdit && <CombinedCampaignBudgetEdit />}
      {/*show connect with platform for platforms which are used in right campaigns */}
      {/*i.e. we don't show all platforms from selected partnership, but only those which are used in right campaigns*/}
      <SocialAuthCheckerMulti platforms={availablePlatformCampaigns}>
        <RightCampaigns />
      </SocialAuthCheckerMulti>
      {showRightCampaignsReports && <RightCampaignsReports />}
    </>
  )
}

export default DigitalRight
